import script from "./BulkRegisterModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkRegisterModal.vue?vue&type=script&setup=true&lang=ts"

import "./BulkRegisterModal.vue?vue&type=style&index=0&id=6d09c007&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d09c007"]])

export default __exports__